export default __webpack_public_path__ + "static/media/Logo_Ayto_sinfondo.1c4d76ca.png";